import React, { useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import GradingCategoryList from './GradingCategoryList';
import { FindInPage } from '@material-ui/icons';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const GradingCategory = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, GradingCategoryID: null, redirectPath: '' });

    let visible = columns && columns['GradingCategory'];
    const tableColumns = useMemo(() => {
        return [
            {
                title: translations["action"] || "Action", field: 'Action',
                hidden: visible ? visible['Action'] : false,
                cellStyle: { minWidth: 100, maxWidth: 100 },
                filtering: false,
                render: rowData => <>
                    {
                        hasPermission(permissions, 'grading_category_load') ? <Tooltip title={translations["grading_category_details"] || "Grading category details"}>
                            <IconButton value={rowData.GradingCategoryID} aria-label={translations["grading_category_details"] || "Grading category details"} onClick={() => redirectHandler(`/admin/grade-category/edit?GradingCategoryID=${rowData.GradingCategoryID}`)}>
                                <FindInPage />
                            </IconButton>
                        </Tooltip> : <div></div>
                    }
                </>
            },
            {
                title: translations["grading_product"] || 'Product', field: 'Product',
                hidden: visible ? visible['Product'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Product ? rowData.Product : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["deleted"] || 'Deleted', field: 'Deleted',
                hidden: visible ? visible['Deleted'] : false,
                lookup: { '0': translations['no'] || 'No', '1': translations['yes'] || 'Yes' },
                defaultFilter: ['0'],
                filtering: true,
                width: 100,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
                }
            }
        ];
    }, [translations, visible, permissions])

    if (!hasAtLeastOnePermission(permissions, ['grading_category_load'])) {
        tableColumns.shift();
    }

    const redirectHandler = (path, GradingCategoryID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, GradingCategoryID: GradingCategoryID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'grading_category_list') ?
                <GradingCategoryList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(GradingCategory));
